import request from '@/utils/request'

/**
 * 添加 / 修改
 * @param {*} params
 */
export function addPosition(params) {
  return request({
    url: '/post/save',
    method: 'post',
    data: params
  })
}
/**
 * 通过id删除
 */
export function deletePosition(id) {
  return request({
    url: `/post/delete/${id}`,
    method: 'delete',
  })
}

/**
 * 修改
 * @param {*} params
 */
export function editPosition(params) {
  return request({
    url: '/post/update',
    method: 'put',
    data: params
  })
}
